(function () {
  'use strict';

  // Palette sync revision 2: A&M Maroon #a72671.

  var TEAM_COLOR_HEX = {
    'Black': '#000000',
    'Charcoal': '#2F3437',
    'Medium Grey': '#504F52',
    'Grey': '#696A6C',
    'Light Grey': '#DBDCDD',
    'White': '#FFFFFF',
    'Army': '#C3C0B4',
    'Dark Army': '#A39F94',
    'Cream': '#FFF4DA',
    'Sand': '#E4D3A9',
    'Desert': '#D4C6AB',
    'Camel': '#BCA880',
    'Dark Sand': '#9E865E',
    'Teal': '#00A594',
    'Vegas Gold': '#C29F67',
    'Gold': '#FBB216',
    'Yellow': '#FFD300',
    'Dark Gold': '#DE9716',
    'Optic Yellow': '#ECE847',
    'Volt': '#CEFF00',
    'NM Yellow': '#FFFF1A',
    'Electric Green': '#79C153',
    'Kelly Green': '#009647',
    'Dark Green': '#005D29',
    'Miami Green': '#015130',
    'Dark Teal': '#007064',
    'Sea Foam': '#77C5BC',
    'Forest': '#2C553C',
    'Army Green': '#425037',
    'Dark Forest': '#062E1B',
    'Hunter Green': '#283521',
    'Brown': '#3E2E2D',
    'Texas Orange': '#894630',
    'Blood Red': '#6F0010',
    'Maroon': '#670F26',
    'A&M Maroon': '#a72671',
    'Red': '#9D182E',
    'Hot Pink': '#B12960',
    'Pink': '#F1809F',
    'Raspberry': '#ED3D7F',
    'Dark Orange': '#B12E16',
    'Hot Orange': '#BC4F18',
    'Orange': '#EE4023',
    'Granite Orange': '#F15729',
    'Light Orange': '#F37920',
    'Persimmon': '#F37E55',
    'Miami Orange': '#F15F25',
    'Dark Purple': '#180A3C',
    'NW Purple': '#00002C',
    'Purple': '#413276',
    'Light Purple': '#363857',
    'Tarleton Purple': '#8066FF',
    'Navy': '#000E28',
    'Light Navy': '#2B4256',
    'Light Royal': '#27718D',
    'Midknight Blue': '#004F82',
    'Royal Blue': '#006EB6',
    'Steel': '#5880B2',
    'Cornflower': '#6A90CA',
    'Light Electric Blue': '#69C0E0',
    'Celestial': '#63A7CB',
    'Electric Blue': '#25ABE2',
    'Pale Sky': '#9FC4DC',
    'Dark Electric Blue': '#006682'
  };

  var LEGACY_TEAM_COLOR_NAMES = {
    'Royal': 'Royal Blue',
    'Navy Blue': 'Navy',
    'Forest Green': 'Forest',
    'Gray': 'Grey',
    'Silver Gray': 'Light Grey',
    'Charcoal Gray': 'Charcoal',
    'Athletic Gold': 'Gold'
  };

  function teamColorHex(name, fallback) {
    return TEAM_COLOR_HEX[name] || fallback;
  }

  function normalizeTeamColorName(name) {
    return LEGACY_TEAM_COLOR_NAMES[name] || name;
  }

  function populateTeamColorSelects(root) {
    var selectors = '[data-jm-qbp-color], [data-jm-qbp-text-color], [data-jm-qbp-number-color]';
    Array.prototype.forEach.call(root.querySelectorAll(selectors), function (select) {
      var selectedName = normalizeTeamColorName(String(select.value || ''));
      select.innerHTML = '';

      Object.keys(TEAM_COLOR_HEX).forEach(function (name) {
        var option = document.createElement('option');
        option.value = name;
        option.textContent = name;
        option.dataset.hex = TEAM_COLOR_HEX[name];
        option.selected = name === selectedName;
        select.appendChild(option);
      });

      if (!TEAM_COLOR_HEX[selectedName]) select.value = 'Black';
    });
  }

  function parseJson(root, selector, fallback) {
    try {
      var node = root.querySelector(selector);
      return node ? JSON.parse(node.textContent) : fallback;
    } catch (error) {
      return fallback;
    }
  }

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency || 'USD'
      }).format((Number(cents) || 0) / 100);
    } catch (error) {
      return '$' + ((Number(cents) || 0) / 100).toFixed(2);
    }
  }

  function setText(root, selector, value) {
    var node = root.querySelector(selector);
    if (node) node.textContent = value;
  }

  function setLabelState(root, selector, value, active) {
    var label = root.querySelector(selector);
    if (!label) return;
    label.textContent = value;
    label.classList.toggle('is-added', Boolean(active));
  }

  function initQuickBuy(root) {
    if (root.dataset.gtaQbpReady === 'true') return;
    root.dataset.gtaQbpReady = 'true';

    populateTeamColorSelects(root);

    var config = parseJson(root, '[data-gta-qbp-product]', {});
    // Event delivery and consent are configured in GTM, independently of ordering.
    function trackQuickOrder(action, quantity) {
      try {
        window.dataLayer = window.dataLayer || [];
        var reportingEvent = {
          event: 'gta_feature', gta_feature: 'quick_order', gta_action: action,
          gta_product: String(config.handle || '').slice(0,150),
          gta_quantity: Number.isFinite(quantity) ? quantity : 0,
          gta_step: '', gta_side: '', gta_result: '', gta_store: 'gear',
          gta_tracking_version: '1'
        };
        window.dataLayer.push(reportingEvent);
        if (window.GearFeatureReporting) window.GearFeatureReporting.track(reportingEvent);
        else {
          window.GearFeatureQueue = window.GearFeatureQueue || [];
          if (window.GearFeatureQueue.length < 30) window.GearFeatureQueue.push(reportingEvent);
          if (!document.querySelector('script[data-gear-feature-reporting]')) {
            var trackingScript = document.createElement('script');
            trackingScript.src = 'https://jersey-design-extractor.vercel.app/feature-tracking.js';
            trackingScript.async = true;
            trackingScript.dataset.gearFeatureReporting = 'true';
            document.head.appendChild(trackingScript);
          }
        }
      } catch (_) { /* Analytics must never prevent an order. */ }
    }
    var isBackpack = config.productKind === 'backpack';
    var isPants = config.productKind === 'pants';
    var itemSingular = isBackpack ? 'backpack' : isPants ? 'pair of pants' : 'jersey';
    var itemPlural = isBackpack ? 'backpacks' : isPants ? 'pairs of pants' : 'jerseys';
    var itemTitle = isBackpack ? 'Backpack' : isPants ? 'Pants' : 'Jersey';
    function outputPlacement(placement) {
      if (isPants) return ({'Left Crest':'Left Thigh','Right Crest':'Right Thigh'})[placement] || placement;
      if (!isBackpack) return placement;
      if (placement === 'Middle Front') return 'Upper Center';
      if (placement === 'Right Crest') return 'Lower Center';
      return placement;
    }
    var modal = root.querySelector('[data-jm-qbp-modal]');
    var players = root.querySelector('[data-jm-qbp-players]');
    var playerTemplate = root.querySelector('[data-jm-qbp-player-template]');
    var status = root.querySelector('[data-jm-qbp-status]');
    var validation = root.querySelector('[data-jm-qbp-validation]');
    var submit = root.querySelector('[data-jm-qbp-submit]');
    var lastTrigger = null;
    var lastAnnouncedDiscount = null;
    var variantChoices = (config.variants || [])
      .filter(function (variant) { return variant.available !== false; })
      .map(function (variant) {
        return {
          id: Number(variant.id),
          title: variant.title || itemTitle,
          price: Number(variant.price) || 0
        };
      });

    if (isBackpack && variantChoices.length) {
      variantChoices = [{
        id: variantChoices[0].id,
        title: 'One Size',
        price: variantChoices[0].price
      }];
    }

    if (
      !isBackpack &&
      variantChoices.length === 1 &&
      /default title/i.test(variantChoices[0].title || '') &&
      Array.isArray(config.fallbackSizes)
    ) {
      variantChoices = config.fallbackSizes.map(function (size) {
        return {
          id: variantChoices[0].id,
          title: size,
          price: variantChoices[0].price
        };
      });
    }

    function populateVariantSelect(select, selectedTitle) {
      if (!select || !variantChoices.length) return;
      select.innerHTML = '';
      variantChoices.forEach(function (variant, index) {
        var option = document.createElement('option');
        option.value = String(variant.id);
        option.dataset.price = String(variant.price);
        option.dataset.size = variant.title;
        option.textContent = variant.title;
        option.selected = selectedTitle ? variant.title === selectedTitle : index === 0;
        select.appendChild(option);
      });
      if (isBackpack) {
        select.disabled = true;
        select.setAttribute('aria-label', 'Size: One Size');
      }
    }

    root.querySelectorAll('[data-jm-qbp-player] [data-jm-qbp-variant]').forEach(function (select) {
      populateVariantSelect(select);
    });
    if (playerTemplate && playerTemplate.content) {
      populateVariantSelect(playerTemplate.content.querySelector('[data-jm-qbp-variant]'));
    }

    function getPlayers() {
      return Array.prototype.slice.call(players.querySelectorAll('[data-jm-qbp-player]'));
    }

    function selectedChoice(player) {
      var select = player.querySelector('[data-jm-qbp-variant]');
      var option = select && select.options[select.selectedIndex];
      return {
        id: select ? Number(select.value) : 0,
        size: option ? (option.dataset.size || option.textContent.trim()) : '',
        price: option ? Number(option.dataset.price) || 0 : 0,
        number: (player.querySelector('[data-jm-qbp-player-number]') || {}).value || ''
      };
    }

    function activeTier(count) {
      var tiers = config.discountTiers || [{ minimum: 1, discount: 0, label: 'Retail price' }];
      var active = tiers[0];
      tiers.forEach(function (tier) {
        if (count >= Number(tier.minimum || 1)) active = tier;
      });
      return active;
    }

    function tierRange(index) {
      var tiers = config.discountTiers || [];
      var current = tiers[index];
      var next = tiers[index + 1];
      if (!current) return '';
      return next
        ? current.minimum + '–' + (Number(next.minimum) - 1) + ' ' + itemPlural
        : current.minimum + '+ ' + itemPlural;
    }

    function checked(selector) {
      var input = root.querySelector(selector);
      return Boolean(input && input.checked);
    }

    function checkedValues(selector) {
      return Array.prototype.map.call(
        root.querySelectorAll(selector + ':checked'),
        function (input) { return String(input.value || '').trim(); }
      ).filter(Boolean);
    }

    function value(selector) {
      var input = root.querySelector(selector);
      return input ? String(input.value || '').trim() : '';
    }

    function fontPreviewFamily(name) {
      var normalized = String(name || '').toLowerCase();
      if (normalized.indexOf('varsity') !== -1) {
        return 'Rockwell, "Roboto Slab", "Courier New", serif';
      }
      if (normalized.indexOf('modern') !== -1) {
        return '"Arial Black", Arial, Helvetica, sans-serif';
      }
      if (normalized.indexOf('stencil') !== -1) {
        return '"Stencil Std", "Copperplate Gothic Bold", Impact, sans-serif';
      }
      return 'Impact, Haettenschweiler, "Arial Narrow Bold", sans-serif';
    }

    function applyPreviewFont(element, name) {
      if (!element) return;
      element.style.fontFamily = fontPreviewFamily(name);
      element.style.letterSpacing = String(name || '').toLowerCase().indexOf('stencil') !== -1 ? '.08em' : '';
    }

    function textFontOption(name) {
      var match = null;
      Array.prototype.some.call(root.querySelectorAll('[data-jm-qbp-text-font]'), function (input) {
        if (String(input.value || '') === String(name || '')) {
          match = input.closest('.jm-qbp__font-option');
          return true;
        }
        return false;
      });
      return match;
    }

    function textFontFamily(name) {
      var option = textFontOption(name);
      var sample = option ? option.querySelector('small') : null;
      return sample ? window.getComputedStyle(sample).fontFamily : fontPreviewFamily(name);
    }

    function applyTextPreviewFont(element, name) {
      if (!element) return;
      element.style.fontFamily = textFontFamily(name);
      element.style.letterSpacing = '';
    }

    function textFontSampleValue(preferredField) {
      var preferredValue = preferredField ? String(preferredField.value || '').trim() : '';
      if (preferredValue) return preferredValue;

      var middleFront = placementField('[data-jm-qbp-team-text]', 'Middle Front');
      var middleFrontValue = middleFront ? String(middleFront.value || '').trim() : '';
      if (middleFrontValue) return middleFrontValue;

      var firstEnteredValue = '';
      Array.prototype.some.call(root.querySelectorAll('[data-jm-qbp-team-text]'), function (field) {
        firstEnteredValue = String(field.value || '').trim();
        return Boolean(firstEnteredValue);
      });
      return firstEnteredValue || 'GEAR 24';
    }

    function syncTextFontSamples(preferredField) {
      var sampleValue = textFontSampleValue(preferredField);
      root.querySelectorAll('[data-jm-qbp-font-dropdown] .jm-qbp__font-option--dropdown small').forEach(function (sample) {
        sample.textContent = sampleValue;
      });
      var currentSample = root.querySelector('[data-jm-qbp-font-current-sample]');
      if (currentSample) currentSample.textContent = sampleValue;
    }

    function syncTextFontDropdown() {
      var dropdown = root.querySelector('[data-jm-qbp-font-dropdown]');
      var selected = root.querySelector('[data-jm-qbp-text-font]:checked');
      if (!dropdown || !selected) return;
      syncTextFontSamples();
      var family = textFontFamily(selected.value);
      var name = dropdown.querySelector('[data-jm-qbp-font-current-name]');
      var sample = dropdown.querySelector('[data-jm-qbp-font-current-sample]');
      if (name) {
        name.textContent = selected.value;
        name.style.fontFamily = family;
      }
      if (sample) sample.style.fontFamily = family;
    }

    function filterTextFonts(query) {
      var normalized = String(query || '').trim().toLowerCase();
      var visible = 0;
      root.querySelectorAll('.jm-qbp__font-options--dropdown [data-font-name]').forEach(function (option) {
        var matches = !normalized || String(option.dataset.fontName || '').toLowerCase().indexOf(normalized) !== -1;
        option.hidden = !matches;
        if (matches) visible += 1;
      });
      var empty = root.querySelector('[data-jm-qbp-font-empty]');
      if (empty) empty.hidden = visible > 0;
    }

    function numberFontOption(name) {
      var match = null;
      Array.prototype.some.call(root.querySelectorAll('[data-jm-qbp-number-style]'), function (input) {
        if (String(input.value || '') === String(name || '')) {
          match = input.closest('.jm-qbp__font-option');
          return true;
        }
        return false;
      });
      return match;
    }

    function numberFontFamily(name) {
      var option = numberFontOption(name);
      var sample = option ? option.querySelector('small') : null;
      return sample ? window.getComputedStyle(sample).fontFamily : fontPreviewFamily(name);
    }

    function applyNumberPreviewFont(element, name) {
      if (!element) return;
      element.style.fontFamily = numberFontFamily(name);
      element.style.letterSpacing = '';
    }

    function numberFontSampleValue(preferredField) {
      var preferredValue = preferredField ? String(preferredField.value || '').trim() : '';
      if (preferredValue) return preferredValue;
      var firstValue = '';
      Array.prototype.some.call(root.querySelectorAll('[data-jm-qbp-player-number]'), function (field) {
        firstValue = String(field.value || '').trim();
        return Boolean(firstValue);
      });
      return firstValue || '24';
    }

    function syncNumberFontSamples(preferredField) {
      var sampleValue = numberFontSampleValue(preferredField);
      root.querySelectorAll('[data-jm-qbp-number-font-dropdown] .jm-qbp__font-option--dropdown small').forEach(function (sample) {
        sample.textContent = sampleValue;
      });
      var currentSample = root.querySelector('[data-jm-qbp-number-font-current-sample]');
      if (currentSample) currentSample.textContent = sampleValue;
    }

    function syncNumberFontDropdown() {
      var dropdown = root.querySelector('[data-jm-qbp-number-font-dropdown]');
      var selected = root.querySelector('[data-jm-qbp-number-style]:checked');
      if (!dropdown || !selected) return;
      syncNumberFontSamples();
      var family = numberFontFamily(selected.value);
      var name = dropdown.querySelector('[data-jm-qbp-number-font-current-name]');
      var sample = dropdown.querySelector('[data-jm-qbp-number-font-current-sample]');
      if (name) {
        name.textContent = selected.value;
        name.style.fontFamily = family;
      }
      if (sample) sample.style.fontFamily = family;
    }

    function filterNumberFonts(query) {
      var normalized = String(query || '').trim().toLowerCase();
      var visible = 0;
      root.querySelectorAll('[data-jm-qbp-number-font-option]').forEach(function (option) {
        var matches = !normalized || String(option.dataset.fontName || '').toLowerCase().indexOf(normalized) !== -1;
        option.hidden = !matches;
        if (matches) visible += 1;
      });
      var empty = root.querySelector('[data-jm-qbp-number-font-empty]');
      if (empty) empty.hidden = visible > 0;
    }

    function placementField(selector, placement) {
      var match = null;
      Array.prototype.some.call(root.querySelectorAll(selector), function (field) {
        if ((field.dataset.placement || field.value) === placement) {
          match = field;
          return true;
        }
        return false;
      });
      return match;
    }

    function placementValue(selector, placement) {
      var field = placementField(selector, placement);
      return field ? String(field.value || '').trim() : '';
    }

    function placementIsSelected(selector, placement) {
      var field = placementField(selector, placement);
      return Boolean(field && field.checked);
    }

    function clearPlacement(type, placement) {
      var placementSelector = type === 'logo' ? '[data-jm-qbp-logo-placement]' : '[data-jm-qbp-text-placement]';
      var placementInput = placementField(placementSelector, placement);
      if (placementInput) placementInput.checked = false;

      if (type === 'logo') {
        var fileInput = placementField('[data-jm-qbp-logo-file]', placement);
        if (fileInput) fileInput.value = '';

        Array.prototype.some.call(root.querySelectorAll('[data-jm-qbp-preview-logo]'), function (previewLogo) {
          if (previewLogo.dataset.placement !== placement) return false;
          var logoImage = previewLogo.querySelector('[data-jm-qbp-logo-image]');
          var logoFallback = previewLogo.querySelector('[data-jm-qbp-logo-fallback]');
          if (logoImage) {
            var source = logoImage.getAttribute('src') || '';
            if (source.indexOf('blob:') === 0 && window.URL && window.URL.revokeObjectURL) {
              window.URL.revokeObjectURL(source);
            }
            logoImage.removeAttribute('src');
            logoImage.hidden = true;
          }
          if (logoFallback) logoFallback.hidden = false;
          previewLogo.hidden = true;
          return true;
        });
      } else {
        var textInput = placementField('[data-jm-qbp-team-text]', placement);
        if (textInput) textInput.value = '';
        syncTextFontSamples();
      }

      var toggle = root.querySelector(type === 'logo' ? '[data-jm-qbp-logo-toggle]' : '[data-jm-qbp-text-toggle]');
      if (toggle) toggle.checked = checkedValues(placementSelector).length > 0;
      update();
    }

    function personalizationParts() {
      var parts = [];
      if (checked('[data-jm-qbp-logo-toggle]')) {
        var logoCount = checkedValues('[data-jm-qbp-logo-placement]').length;
        parts.push('Team logo' + (logoCount > 1 ? ' (' + logoCount + ' locations)' : ''));
      }
      if (checked('[data-jm-qbp-text-toggle]')) {
        var textCount = checkedValues('[data-jm-qbp-text-placement]').length;
        parts.push('Team text' + (textCount > 1 ? ' (' + textCount + ' locations)' : ''));
      }
      if (checked('[data-jm-qbp-numbers-toggle]')) parts.push('Player numbers');
      return parts;
    }

    function updatePreview() {
      var logoOn = checked('[data-jm-qbp-logo-toggle]');
      var textOn = checked('[data-jm-qbp-text-toggle]');
      var numbersOn = checked('[data-jm-qbp-numbers-toggle]');
      var frontOn = numbersOn && checked('[data-jm-qbp-front-toggle]');
      var firstPlayer = getPlayers()[0];
      var firstNumber = firstPlayer ? selectedChoice(firstPlayer).number || '7' : '7';
      var previewLogos = root.querySelectorAll('[data-jm-qbp-preview-logo]');
      var previewTexts = root.querySelectorAll('[data-jm-qbp-preview-text]');
      var previewFront = root.querySelector('[data-jm-qbp-preview-front-number]');
      var previewBack = root.querySelector('[data-jm-qbp-preview-back-number]');
      var frontStage = previewFront ? previewFront.parentElement : null;
      var logoPlacements = checkedValues('[data-jm-qbp-logo-placement]');
      var textPlacements = checkedValues('[data-jm-qbp-text-placement]');
      var textFont = value('[data-jm-qbp-text-font]:checked');
      var numberStyle = value('[data-jm-qbp-number-style]:checked');

      Array.prototype.forEach.call(previewLogos, function (previewLogo) {
        var placement = previewLogo.dataset.placement;
        previewLogo.hidden = !logoOn || logoPlacements.indexOf(placement) === -1;
        previewLogo.dataset.size = value('[data-jm-qbp-logo-size]') || 'Standard';
      });
      Array.prototype.forEach.call(previewTexts, function (previewText) {
        var placement = previewText.dataset.placement;
        previewText.hidden = !textOn || textPlacements.indexOf(placement) === -1;
        previewText.textContent = placementValue('[data-jm-qbp-team-text]', placement) || 'TEAM';
        previewText.style.color = teamColorHex(value('[data-jm-qbp-text-color]'), '#FFFFFF');
        applyTextPreviewFont(previewText, textFont);
      });
      if (previewFront) {
        previewFront.hidden = !frontOn;
        previewFront.textContent = firstNumber;
        previewFront.style.color = teamColorHex(value('[data-jm-qbp-number-color]'), '#000000');
        applyNumberPreviewFont(previewFront, numberStyle);
      }
      if (previewBack) {
        previewBack.hidden = !numbersOn;
        previewBack.textContent = firstNumber;
        previewBack.style.color = teamColorHex(value('[data-jm-qbp-number-color]'), '#000000');
        applyNumberPreviewFont(previewBack, numberStyle);
      }
      if (frontStage) {
        var middleLogoOn = logoOn && logoPlacements.indexOf('Middle Front') !== -1;
        var middleTextOn = textOn && textPlacements.indexOf('Middle Front') !== -1;
        var leftLogoOn = logoOn && logoPlacements.indexOf('Left Crest') !== -1;
        var leftTextOn = textOn && textPlacements.indexOf('Left Crest') !== -1;
        var rightLogoOn = logoOn && logoPlacements.indexOf('Right Crest') !== -1;
        var rightTextOn = textOn && textPlacements.indexOf('Right Crest') !== -1;
        var leftSleeveLogoOn = logoOn && logoPlacements.indexOf('Left Sleeve') !== -1;
        var leftSleeveTextOn = textOn && textPlacements.indexOf('Left Sleeve') !== -1;
        var rightSleeveLogoOn = logoOn && logoPlacements.indexOf('Right Sleeve') !== -1;
        var rightSleeveTextOn = textOn && textPlacements.indexOf('Right Sleeve') !== -1;
        frontStage.classList.toggle('has-front-number', frontOn);
        frontStage.classList.toggle('has-middle-logo', middleLogoOn);
        frontStage.classList.toggle('has-middle-text', middleTextOn);
        frontStage.classList.toggle('has-middle-content', middleLogoOn || middleTextOn);
        frontStage.classList.toggle('has-left-logo-text', leftLogoOn && leftTextOn);
        frontStage.classList.toggle('has-right-logo-text', rightLogoOn && rightTextOn);
        frontStage.classList.toggle('has-left-sleeve-logo-text', leftSleeveLogoOn && leftSleeveTextOn);
        frontStage.classList.toggle('has-right-sleeve-logo-text', rightSleeveLogoOn && rightSleeveTextOn);
      }
    }

    function updateRosterSummary(playerData) {
      var roster = root.querySelector('[data-jm-qbp-roster-summary]');
      if (!roster) return;
      roster.innerHTML = '';
      playerData.forEach(function (player, index) {
        var row = document.createElement('div');
        row.className = 'jm-qbp__summary-player';
        var playerName = document.createElement('span');
        var size = document.createElement('strong');
        var number = document.createElement('b');
        playerName.textContent = (isBackpack ? 'Backpack ' : 'Player ') + (index + 1);
        size.textContent = player.size;
        number.textContent = player.number ? '#' + player.number : 'No number';
        row.appendChild(playerName);
        row.appendChild(size);
        row.appendChild(number);
        roster.appendChild(row);
      });
    }

    function updateMainSummary(playerData, colors, personalizations, pricing) {
      var summary = root.querySelector('[data-jm-qbp-summary]');
      if (!summary) return;
      var sizeCounts = {};
      playerData.forEach(function (player) {
        sizeCounts[player.size] = (sizeCounts[player.size] || 0) + 1;
      });
      var sizeText = Object.keys(sizeCounts).map(function (size) {
        return size + ' ×' + sizeCounts[size];
      }).join(', ');
      var rows = [
        [itemTitle + ' colors', colors],
        [isBackpack ? 'Backpacks' : 'Players', playerData.length + ' total · ' + sizeText],
        ['Team pricing', pricing.discount > 0
          ? pricing.discount + '% off · ' + money(pricing.each, config.currency) + ' each · Save ' + money(pricing.saved, config.currency)
          : 'Regular price · ' + money(pricing.total, config.currency) + ' total'],
        ['Personalization', personalizations.length ? personalizations.join(', ') : 'None']
      ];
      summary.innerHTML = '';
      rows.forEach(function (data) {
        var row = document.createElement('div');
        var term = document.createElement('dt');
        var description = document.createElement('dd');
        term.textContent = data[0];
        description.textContent = data[1];
        row.appendChild(term);
        row.appendChild(description);
        summary.appendChild(row);
      });
    }

    function update() {
      var playerNodes = getPlayers();
      var playerData = playerNodes.map(selectedChoice);
      var count = playerData.length;
      var colors = Array.prototype.map.call(
        root.querySelectorAll('[data-jm-qbp-color]'),
        function (select) { return select.value; }
      ).join(' · ');
      var personalizations = personalizationParts();
      var tier = activeTier(count);
      var discount = Number(tier.discount) || 0;
      var subtotal = playerData.reduce(function (sum, player) { return sum + player.price; }, 0);
      var discountedTotal = Math.round(subtotal * (100 - discount) / 100);
      var firstPrice = playerData[0] ? playerData[0].price : 0;
      var discountedEach = Math.round(firstPrice * (100 - discount) / 100);
      var countLabel = count + ' ' + (count === 1 ? itemSingular : itemPlural);

      playerNodes.forEach(function (player, index) {
        setText(player, '[data-jm-qbp-player-label]', (isBackpack ? 'Backpack ' : 'Player ') + (index + 1));
        var remove = player.querySelector('[data-jm-qbp-remove-player]');
        if (remove) {
          remove.hidden = count === 1;
          remove.setAttribute('aria-label', 'Remove ' + (isBackpack ? 'Backpack ' : 'Player ') + (index + 1));
        }
        var numberField = player.querySelector('[data-jm-qbp-player-number-field]');
        if (numberField) numberField.hidden = false;
      });

      setText(root, '[data-jm-qbp-total-label]', countLabel);
      setText(root, '[data-jm-qbp-total]', money(discountedTotal, config.currency));
      var subtotalNode = root.querySelector('[data-jm-qbp-subtotal]');
      if (subtotalNode) {
        subtotalNode.hidden = discount <= 0;
        subtotalNode.textContent = discount > 0 ? money(subtotal, config.currency) : '';
      }
      var discountBadge = root.querySelector('[data-jm-qbp-discount-badge]');
      if (discountBadge) {
        discountBadge.hidden = discount <= 0;
        discountBadge.textContent = discount > 0 ? discount + '% team discount' : '';
      }
      setText(root, '[data-jm-qbp-player-count]', count);
      setText(root, '[data-jm-qbp-color-summary]', colors);
      setText(root, '[data-jm-qbp-personalization-summary]', personalizations.length ? personalizations.join(', ') : 'None');
      setText(root, '[data-jm-qbp-summary-count]', countLabel);
      setText(root, '[data-jm-qbp-roster-summary-label]', count + ' ' + (count === 1 ? (isBackpack ? 'backpack' : 'player') : (isBackpack ? 'backpacks' : 'players')));

      setLabelState(root, '[data-jm-qbp-colors-label]', colors, true);
      setLabelState(root, '[data-jm-qbp-players-label]', count + ' ' + (count === 1 ? (isBackpack ? 'backpack' : 'player') : (isBackpack ? 'backpacks' : 'players')), true);
      var logoLocationCount = checkedValues('[data-jm-qbp-logo-placement]').length;
      var textLocationCount = checkedValues('[data-jm-qbp-text-placement]').length;
      setLabelState(root, '[data-jm-qbp-logo-label]', checked('[data-jm-qbp-logo-toggle]') ? logoLocationCount + (logoLocationCount === 1 ? ' location' : ' locations') : 'Not added', checked('[data-jm-qbp-logo-toggle]'));
      setLabelState(root, '[data-jm-qbp-text-label]', checked('[data-jm-qbp-text-toggle]') ? textLocationCount + (textLocationCount === 1 ? ' location' : ' locations') : 'Not added', checked('[data-jm-qbp-text-toggle]'));
      setLabelState(root, '[data-jm-qbp-numbers-label]', checked('[data-jm-qbp-numbers-toggle]') ? 'Added' : 'Not added', checked('[data-jm-qbp-numbers-toggle]'));

      root.querySelectorAll('[data-jm-qbp-placement-card]').forEach(function (card) {
        var placement = card.dataset.placement;
        var type = card.dataset.jmQbpPlacementCard;
        var selector = type === 'logo' ? '[data-jm-qbp-logo-placement]' : '[data-jm-qbp-text-placement]';
        var active = placementIsSelected(selector, placement);
        var status = card.querySelector('.jm-qbp__placement-status');
        var removePlacement = card.querySelector('[data-jm-qbp-remove-placement]');
        if (!removePlacement) {
          removePlacement = document.createElement('button');
          removePlacement.type = 'button';
          removePlacement.className = 'jm-qbp__placement-remove';
          removePlacement.dataset.jmQbpRemovePlacement = type;
          removePlacement.dataset.placement = placement;
          removePlacement.textContent = 'Remove';
          var cardHeading = card.querySelector('.jm-qbp__placement-card-heading');
          if (cardHeading) cardHeading.appendChild(removePlacement);
        }
        removePlacement.hidden = !active;
        removePlacement.setAttribute('aria-label', 'Remove ' + type + ' from ' + placement);
        card.classList.toggle('is-active', active);
        if (status) {
          status.hidden = active;
          status.textContent = 'Not used';
        }
        if (type === 'logo') {
          var fileInput = placementField('[data-jm-qbp-logo-file]', placement);
          var fileName = fileInput && fileInput.files && fileInput.files[0] ? fileInput.files[0].name : '';
          var fileNameLabel = card.querySelector('[data-jm-qbp-file-name]');
          if (fileNameLabel) {
            fileNameLabel.textContent = fileName || 'No file chosen';
            fileNameLabel.setAttribute('title', fileName || 'No file chosen');
          }
        }
      });

      var tiers = config.discountTiers || [];
      var activeIndex = Math.max(0, tiers.indexOf(tier));
      root.querySelectorAll('[data-jm-qbp-tier-card]').forEach(function (card, index) {
        var cardTier = tiers[index] || tier;
        var cardPrice = Math.round(firstPrice * (100 - Number(cardTier.discount || 0)) / 100);
        card.classList.toggle('is-active', index === activeIndex);
        setText(card, '[data-jm-qbp-tier-card-price]', money(cardPrice, config.currency) + ' each');
        var cardStatus = card.querySelector('[data-jm-qbp-tier-card-status]');
        if (cardStatus) cardStatus.hidden = index !== activeIndex;
      });
      setText(root, '[data-jm-qbp-tier-summary]', tierRange(activeIndex) + ' · ' + money(discountedEach, config.currency) + ' each');

      var nextTier = tiers[activeIndex + 1];
      var progress = root.querySelector('[data-jm-qbp-tier-progress]');
      if (progress) {
        progress.textContent = nextTier
          ? 'Add ' + (Number(nextTier.minimum) - count) + ' more ' + itemPlural + ' to unlock ' + nextTier.discount + '% off.'
          : 'You unlocked the best team discount.';
      }
      var savings = root.querySelector('[data-jm-qbp-tier-savings]');
      var saved = subtotal - discountedTotal;
      if (savings) {
        savings.hidden = saved <= 0;
        savings.textContent = saved > 0 ? 'Team discount saves ' + money(saved, config.currency) + '.' : '';
      }

      var savingsCallout = root.querySelector('[data-jm-qbp-savings-callout]');
      var savingsTitle = root.querySelector('[data-jm-qbp-savings-title]');
      var savingsMessage = root.querySelector('[data-jm-qbp-savings-message]');
      var savingsValue = root.querySelector('[data-jm-qbp-savings-value]');
      var savingsAmount = root.querySelector('[data-jm-qbp-savings-amount]');
      var savingsFill = root.querySelector('[data-jm-qbp-savings-fill]');
      if (savingsCallout) {
        savingsCallout.dataset.tier = String(activeIndex);
        savingsCallout.classList.toggle('is-unlocked', discount > 0);
        if (lastAnnouncedDiscount !== null && discount > lastAnnouncedDiscount) {
          savingsCallout.classList.remove('is-celebrating');
          void savingsCallout.offsetWidth;
          savingsCallout.classList.add('is-celebrating');
          window.setTimeout(function () {
            savingsCallout.classList.remove('is-celebrating');
          }, 900);
        }
      }
      if (discount <= 0) {
        var jerseysToNext = nextTier ? Number(nextTier.minimum) - count : 0;
        if (savingsTitle) savingsTitle.textContent = jerseysToNext + ' ' + (jerseysToNext === 1 ? itemSingular : itemPlural) + ' away from ' + (nextTier ? nextTier.discount : 0) + '% off';
        if (savingsMessage) savingsMessage.textContent = 'Add ' + jerseysToNext + ' more ' + (jerseysToNext === 1 ? itemSingular : itemPlural) + ' to unlock team pricing.';
      } else if (nextTier) {
        var jerseysToBest = Number(nextTier.minimum) - count;
        if (savingsTitle) savingsTitle.textContent = discount + '% TEAM DISCOUNT UNLOCKED';
        if (savingsMessage) savingsMessage.textContent = 'Your price dropped to ' + money(discountedEach, config.currency) + ' each. Add ' + jerseysToBest + ' more ' + (jerseysToBest === 1 ? itemSingular : itemPlural) + ' to unlock ' + nextTier.discount + '% off.';
      } else {
        if (savingsTitle) savingsTitle.textContent = 'BEST TEAM DISCOUNT UNLOCKED — ' + discount + '% OFF';
        if (savingsMessage) savingsMessage.textContent = 'You unlocked Gear\'s best team price: ' + money(discountedEach, config.currency) + ' each.';
      }
      if (savingsValue) savingsValue.hidden = saved <= 0;
      if (savingsAmount) savingsAmount.textContent = saved > 0 ? money(saved, config.currency) : '';
      if (savingsFill) savingsFill.style.width = Math.max(0, Math.min(100, ((Math.min(count, 13) - 1) / 12) * 100)) + '%';
      root.querySelectorAll('[data-jm-qbp-savings-milestone]').forEach(function (milestone) {
        milestone.classList.toggle('is-reached', count >= Number(milestone.dataset.jmQbpSavingsMilestone));
        milestone.classList.toggle('is-current', Number(milestone.dataset.jmQbpSavingsMilestone) === Number(tier.minimum));
      });
      lastAnnouncedDiscount = discount;

      var logoFields = root.querySelector('[data-jm-qbp-logo-fields]');
      var textFields = root.querySelector('[data-jm-qbp-text-fields]');
      var numberFields = root.querySelector('[data-jm-qbp-numbers-fields]');
      var frontSize = root.querySelector('[data-jm-qbp-front-size-field]');
      if (logoFields) logoFields.hidden = false;
      if (textFields) textFields.hidden = false;
      if (numberFields) numberFields.hidden = !checked('[data-jm-qbp-numbers-toggle]');
      if (frontSize) frontSize.hidden = !checked('[data-jm-qbp-front-toggle]');

      updatePreview();
      updateRosterSummary(playerData);
      updateMainSummary(playerData, colors, personalizations, {
        discount: discount,
        each: discountedEach,
        saved: saved,
        total: discountedTotal
      });
    }

    function addPlayer() {
      if (!playerTemplate || !playerTemplate.content) return;
      var newPlayer = playerTemplate.content.firstElementChild.cloneNode(true);
      populateVariantSelect(newPlayer.querySelector('[data-jm-qbp-variant]'));
      players.appendChild(newPlayer);
      update();
      var select = newPlayer.querySelector('[data-jm-qbp-variant]');
      if (select) select.focus();
    }

    function open(trigger) {
      if (root.hidden) trackQuickOrder('form_open');
      lastTrigger = trigger || null;
      root.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('jm-qbp-is-open');
      update();
      var close = root.querySelector('.jm-qbp__icon-button');
      if (close) close.focus();
    }

    function close() {
      root.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('jm-qbp-is-open');
      if (lastTrigger) lastTrigger.focus();
    }

    function propertyValues(player, index) {
      var properties = {
        'Order Type': 'Quick Buy Personalization',
        'Player': (isBackpack ? 'Backpack ' : 'Player ') + (index + 1),
        '_gta_quick_buy_fee_required': 'true'
      };
      properties[isBackpack ? 'Size' : isPants ? 'Pants Size' : 'Jersey Size'] = player.size;
      if (checked('[data-jm-qbp-numbers-toggle]')) {
        properties['Player Number'] = player.number;
      }
      if (index > 0) return properties;

      properties['Production Worksheet'] = 'Download the CSV attached below';
      properties['Color 1 - Main'] = value('[data-jm-qbp-color="1"]');
      properties['Color 2 - Secondary'] = value('[data-jm-qbp-color="2"]');
      properties['Color 3 - Accent'] = value('[data-jm-qbp-color="3"]');
      properties['Mock-up Approval'] = value('[data-jm-qbp-mockup-toggle]:checked') === 'required' ? 'Required' : 'Not requested';
      if (checked('[data-jm-qbp-logo-toggle]')) {
        var logoPlacements = checkedValues('[data-jm-qbp-logo-placement]');
        properties['Logo Placements'] = logoPlacements.map(outputPlacement).join(', ');
        properties['Logo Size'] = value('[data-jm-qbp-logo-size]');
        logoPlacements.forEach(function (placement) {
          var fileInput = placementField('[data-jm-qbp-logo-file]', placement);
          if (fileInput && fileInput.files && fileInput.files[0]) {
            properties['Logo File - ' + outputPlacement(placement)] = fileInput.files[0].name;
          }
        });
      }
      if (checked('[data-jm-qbp-text-toggle]')) {
        var textPlacements = checkedValues('[data-jm-qbp-text-placement]');
        properties['Text Font'] = value('[data-jm-qbp-text-font]:checked');
        properties['Text Color'] = value('[data-jm-qbp-text-color]');
        properties['Text Placements'] = textPlacements.map(outputPlacement).join(', ');
        textPlacements.forEach(function (placement) {
          properties['Text - ' + outputPlacement(placement)] = placementValue('[data-jm-qbp-team-text]', placement);
        });
      }
      if (checked('[data-jm-qbp-numbers-toggle]')) {
        properties['Number Style'] = value('[data-jm-qbp-number-style]:checked');
        properties['Number Color'] = value('[data-jm-qbp-number-color]');
        properties[isBackpack ? 'Number Size' : 'Back Number Size'] = value('[data-jm-qbp-back-size]');
        if (checked('[data-jm-qbp-front-toggle]')) {
          properties['Front Number Size'] = value('[data-jm-qbp-front-size]');
        }
      }
      return properties;
    }

    function csvCell(valueToEscape) {
      var cell = String(valueToEscape == null ? '' : valueToEscape);
      return '"' + cell.replace(/"/g, '""') + '"';
    }

    function buildProductionCsv(playerData, logoFiles) {
      var textPlacements = checkedValues('[data-jm-qbp-text-placement]');
      var logoPlacements = checkedValues('[data-jm-qbp-logo-placement]');
      var columns = [
        isBackpack ? 'Backpack' : 'Player', isBackpack ? 'Size' : isPants ? 'Pants Size' : 'Jersey Size', 'Player Number',
        'Main Color', 'Secondary Color', 'Accent Color',
        'Logo Placements', 'Logo Size', 'Logo Files',
        'Text Font', 'Text Color', 'Text Placements',
        'Text - ' + outputPlacement('Left Crest'), 'Text - ' + outputPlacement('Middle Front'), 'Text - ' + outputPlacement('Right Crest'), 'Text - Left Sleeve', 'Text - Right Sleeve',
        'Number Style', 'Number Color', 'Back Number Size', 'Front Number Size', 'Mock-up Approval'
      ];
      var shared = {
        main: value('[data-jm-qbp-color="1"]'),
        secondary: value('[data-jm-qbp-color="2"]'),
        accent: value('[data-jm-qbp-color="3"]'),
        logoPlacements: logoPlacements.map(outputPlacement).join(' | '),
        logoSize: checked('[data-jm-qbp-logo-toggle]') ? value('[data-jm-qbp-logo-size]') : '',
        logoFiles: logoFiles.map(function (logo) { return outputPlacement(logo.placement) + ': ' + logo.file.name; }).join(' | '),
        textFont: checked('[data-jm-qbp-text-toggle]') ? value('[data-jm-qbp-text-font]:checked') : '',
        textColor: checked('[data-jm-qbp-text-toggle]') ? value('[data-jm-qbp-text-color]') : '',
        textPlacements: textPlacements.map(outputPlacement).join(' | '),
        numberStyle: checked('[data-jm-qbp-numbers-toggle]') ? value('[data-jm-qbp-number-style]:checked') : '',
        numberColor: checked('[data-jm-qbp-numbers-toggle]') ? value('[data-jm-qbp-number-color]') : '',
        backSize: checked('[data-jm-qbp-numbers-toggle]') ? value('[data-jm-qbp-back-size]') : '',
        frontSize: checked('[data-jm-qbp-front-toggle]') ? value('[data-jm-qbp-front-size]') : '',
        mockup: value('[data-jm-qbp-mockup-toggle]:checked') === 'required' ? 'Required' : 'Not requested'
      };
      var lines = [columns.map(csvCell).join(',')];
      playerData.forEach(function (player, index) {
        lines.push([
          (isBackpack ? 'Backpack ' : 'Player ') + (index + 1), player.size, checked('[data-jm-qbp-numbers-toggle]') ? player.number : '',
          shared.main, shared.secondary, shared.accent,
          shared.logoPlacements, shared.logoSize, shared.logoFiles,
          shared.textFont, shared.textColor, shared.textPlacements,
          placementValue('[data-jm-qbp-team-text]', 'Left Crest'),
          placementValue('[data-jm-qbp-team-text]', 'Middle Front'),
          placementValue('[data-jm-qbp-team-text]', 'Right Crest'),
          placementValue('[data-jm-qbp-team-text]', 'Left Sleeve'),
          placementValue('[data-jm-qbp-team-text]', 'Right Sleeve'),
          shared.numberStyle, shared.numberColor, shared.backSize, shared.frontSize, shared.mockup
        ].map(csvCell).join(','));
      });
      return '\uFEFF' + lines.join('\r\n');
    }

    function bestUploadUrl(uploadValue) {
      var candidates = uploadValue;
      if (typeof candidates === 'string' && candidates.charAt(0) === '[') {
        try { candidates = JSON.parse(candidates); } catch (error) { candidates = [candidates]; }
      }
      if (!Array.isArray(candidates)) candidates = [candidates];
      return candidates.filter(Boolean).find(function (candidate) { return String(candidate).indexOf('_small.') === -1; }) || candidates.filter(Boolean)[0] || '';
    }

    async function makeUploadedFilesReadable(item, logoFiles) {
      if (!item || !item.key || !item.properties) return item;
      var properties = Object.assign({}, item.properties);
      var rosterUrl = bestUploadUrl(properties['Production Roster CSV']);
      if (rosterUrl) {
        delete properties['Production Roster CSV'];
        properties['DOWNLOAD - Production Roster CSV'] = rosterUrl;
      }
      logoFiles.forEach(function (logo) {
        var uploadKey = 'Team Logo - ' + outputPlacement(logo.placement);
        var artworkUrl = bestUploadUrl(properties[uploadKey]);
        if (artworkUrl) {
          delete properties[uploadKey];
          properties['DOWNLOAD ARTWORK - ' + outputPlacement(logo.placement)] = artworkUrl;
        }
      });
      var response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: item.key, quantity: item.quantity || 1, properties: properties })
      });
      if (!response.ok) throw new Error(await response.text());
      return response.json();
    }

    function groupPlayersBySize(playerData) {
      var groups = [];
      var grouped = {};
      playerData.forEach(function (player, index) {
        var key = String(player.id) + '::' + String(player.size || '');
        if (!grouped[key]) {
          grouped[key] = {
            id: player.id,
            size: player.size,
            firstPlayer: player,
            firstPlayerIndex: index,
            players: []
          };
          groups.push(grouped[key]);
        }
        grouped[key].players.push(player);
      });
      return groups;
    }

    async function addGroupedLineItem(group, groupIndex, logoFiles, productionFile, totalPlayers, orderToken) {
      var formData = new FormData();
      formData.append('id', String(group.id));
      formData.append('quantity', String(group.players.length));
      var properties = propertyValues(group.firstPlayer, group.firstPlayerIndex);
      delete properties.Player;
      delete properties['Player Number'];
      delete properties['Jersey Size'];
      delete properties['Pants Size'];
      delete properties.Size;
      properties[isBackpack ? 'Size' : isPants ? 'Pants Size' : 'Jersey Size'] = group.size;
      properties['Size Quantity'] = group.size + ' × ' + group.players.length;
      if (groupIndex === 0) {
        properties.Roster = totalPlayers + ' ' + (totalPlayers === 1 ? itemSingular : itemPlural) + ' — see Production Roster CSV';
      }
      properties._gta_quick_buy_order = orderToken;
      Object.keys(properties).forEach(function (key) {
        if (properties[key] !== '') formData.append('properties[' + key + ']', properties[key]);
      });
      if (groupIndex === 0 && logoFiles.length) {
        logoFiles.forEach(function (logo) {
          formData.append('properties[Team Logo - ' + outputPlacement(logo.placement) + ']', logo.file, logo.file.name);
        });
      }
      if (groupIndex === 0 && productionFile) {
        formData.append('properties[Production Roster CSV]', productionFile, productionFile.name);
      }
      var response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData
      });
      if (!response.ok) throw new Error(await response.text());
      var item = await response.json();
      if (groupIndex === 0) await makeUploadedFilesReadable(item, logoFiles);
      return item;
    }

    async function submitOrder() {
      var playerData = getPlayers().map(selectedChoice);
      var needsNumbers = checked('[data-jm-qbp-numbers-toggle]');
      var selectedLogoPlacements = checkedValues('[data-jm-qbp-logo-placement]');
      var selectedTextPlacements = checkedValues('[data-jm-qbp-text-placement]');
      var missingLogoPlacement = checked('[data-jm-qbp-logo-toggle]') && !selectedLogoPlacements.length;
      var missingTextPlacement = checked('[data-jm-qbp-text-toggle]') && !selectedTextPlacements.length;
      var missingLogoFile = checked('[data-jm-qbp-logo-toggle]') && selectedLogoPlacements.some(function (placement) {
        var input = placementField('[data-jm-qbp-logo-file]', placement);
        return !input || !input.files || !input.files[0];
      });
      var missingTextValue = checked('[data-jm-qbp-text-toggle]') && selectedTextPlacements.some(function (placement) {
        return !placementValue('[data-jm-qbp-team-text]', placement);
      });
      var invalidNumber = needsNumbers && playerData.some(function (player) {
        var playerNumber = String(player.number || '').trim();
        return playerNumber && !/^[0-9]{1,2}$/.test(playerNumber);
      });
      if (!playerData.length || playerData.some(function (player) { return !player.id; }) || invalidNumber || missingLogoPlacement || missingTextPlacement || missingLogoFile || missingTextValue) {
        trackQuickOrder('validation_error');
        validation.hidden = false;
        validation.textContent = missingLogoPlacement
          ? 'Please choose at least one location for the team logo.'
          : missingLogoFile
            ? 'Please upload a separate logo file for every selected logo location.'
          : missingTextPlacement
            ? 'Please choose at least one location for the team text.'
            : missingTextValue
              ? 'Please enter the text needed at every selected text location.'
            : invalidNumber
              ? 'Player numbers are optional. When entered, use one or two digits.'
              : isBackpack ? 'Please choose an option for every backpack.' : 'Please choose a ' + (isPants ? 'pants' : 'jersey') + ' size for every player.';
        return;
      }
      validation.hidden = true;
      status.className = '';
      status.textContent = '';
      trackQuickOrder('cart_add_started', playerData.length);
      submit.disabled = true;
      submit.firstChild.textContent = 'Adding ' + itemPlural + ' ';

      try {
        var cartResponse = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
        if (!cartResponse.ok) throw new Error('Unable to read cart.');
        var cart = await cartResponse.json();
        var feeVariantId = Number(config.feeVariantId);
        var feeExists = cart.items.some(function (item) {
          return Number(item.variant_id) === feeVariantId;
        });
        if (!feeExists && feeVariantId) {
          var feeResponse = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [{
                id: feeVariantId,
                quantity: 1,
                properties: {
                  'Fee Type': 'Quick Buy Production',
                  '_gta_required_quick_buy_fee': 'true'
                }
              }]
            })
          });
          if (!feeResponse.ok) throw new Error(await feeResponse.text());
        }

        var logoFiles = [];
        if (checked('[data-jm-qbp-logo-toggle]')) {
          selectedLogoPlacements.forEach(function (placement) {
            var logoInput = placementField('[data-jm-qbp-logo-file]', placement);
            if (logoInput && logoInput.files && logoInput.files[0]) {
              logoFiles.push({ placement: placement, file: logoInput.files[0] });
            }
          });
        }
        var productionFile = new File(
          [buildProductionCsv(playerData, logoFiles)],
          'quick-buy-production-' + (config.handle || 'jersey') + '.csv',
          { type: 'text/csv;charset=utf-8' }
        );
        var groupedPlayers = groupPlayersBySize(playerData);
        var orderToken = 'gta-' + Date.now().toString(36);
        for (var groupIndex = 0; groupIndex < groupedPlayers.length; groupIndex += 1) {
          await addGroupedLineItem(groupedPlayers[groupIndex], groupIndex, logoFiles, productionFile, playerData.length, orderToken);
        }
        trackQuickOrder('cart_add_succeeded', playerData.length);
        status.className = 'is-success';
        status.textContent = (isBackpack ? 'Backpacks' : isPants ? 'Pants' : 'Jerseys') + ' grouped by option and added. Opening your cart…';
        var discountCode = '';
        if (config.discountCodes) {
          if (playerData.length >= 13) discountCode = config.discountCodes['50'] || '';
          else if (playerData.length >= 5) discountCode = config.discountCodes['25'] || '';
        }
        window.location.assign(discountCode
          ? '/discount/' + encodeURIComponent(discountCode) + '?redirect=/cart'
          : '/cart');
      } catch (error) {
        trackQuickOrder('cart_add_failed', playerData.length);
        status.className = 'is-error';
        status.textContent = 'We could not add the ' + itemPlural + '. Please review your choices and try again.';
        submit.disabled = false;
        submit.firstChild.textContent = 'Add to Cart ';
      }
    }

    // One impression per page/root, only when an ordering button is visible.
    var impressionSent = false;
    var impressionObserver = typeof IntersectionObserver === 'function' ? new IntersectionObserver(function(entries) {
      if (!impressionSent && entries.some(function(entry) { return entry.isIntersecting && entry.intersectionRatio >= 0.5; })) {
        impressionSent = true;
        trackQuickOrder('button_view');
        impressionObserver.disconnect();
      }
    }, {threshold:0.5}) : null;
    document.querySelectorAll('[data-jm-qbp-open]').forEach(function (button) {
      if (impressionObserver) impressionObserver.observe(button);
      button.addEventListener('click', function () { open(button); });
    });
    root.querySelectorAll('[data-jm-qbp-close]').forEach(function (button) {
      button.addEventListener('click', close);
    });
    root.querySelector('[data-jm-qbp-add-player]').addEventListener('click', addPlayer);
    submit.addEventListener('click', submitOrder);

    root.addEventListener('click', function (event) {
      var removePlacement = event.target.closest('[data-jm-qbp-remove-placement]');
      if (removePlacement) {
        event.preventDefault();
        event.stopPropagation();
        clearPlacement(removePlacement.dataset.jmQbpRemovePlacement, removePlacement.dataset.placement);
        return;
      }
      var remove = event.target.closest('[data-jm-qbp-remove-player]');
      if (remove && getPlayers().length > 1) {
        remove.closest('[data-jm-qbp-player]').remove();
        update();
      }
    });
    root.addEventListener('input', function (event) {
      if (event.target.matches('[data-jm-qbp-font-search]')) {
        filterTextFonts(event.target.value);
        return;
      }
      if (event.target.matches('[data-jm-qbp-number-font-search]')) {
        filterNumberFonts(event.target.value);
        return;
      }
      if (event.target.matches('[data-jm-qbp-player-number]') && String(event.target.value || '').trim()) {
        var numbersToggle = root.querySelector('[data-jm-qbp-numbers-toggle]');
        if (numbersToggle) numbersToggle.checked = true;
      }
      if (event.target.matches('[data-jm-qbp-player-number]')) {
        syncNumberFontSamples(event.target);
      }
      if (event.target.matches('[data-jm-qbp-team-text]')) {
        var textToggle = root.querySelector('[data-jm-qbp-text-toggle]');
        var textPlacement = placementField('[data-jm-qbp-text-placement]', event.target.dataset.placement);
        if (textPlacement) textPlacement.checked = Boolean(String(event.target.value || '').trim());
        if (textToggle) textToggle.checked = checkedValues('[data-jm-qbp-text-placement]').length > 0;
        syncTextFontSamples(event.target);
      }
      update();
    });
    root.addEventListener('change', function (event) {
      if (event.target.matches('[data-jm-qbp-text-font]')) {
        syncTextFontDropdown();
        var textFontDropdown = event.target.closest('[data-jm-qbp-font-dropdown]');
        if (textFontDropdown) {
          var textFontSearch = textFontDropdown.querySelector('[data-jm-qbp-font-search]');
          if (textFontSearch) textFontSearch.value = '';
          filterTextFonts('');
          textFontDropdown.open = false;
        }
      }
      if (event.target.matches('[data-jm-qbp-number-style]')) {
        syncNumberFontDropdown();
        var numberFontDropdown = event.target.closest('[data-jm-qbp-number-font-dropdown]');
        if (numberFontDropdown) {
          var numberFontSearch = numberFontDropdown.querySelector('[data-jm-qbp-number-font-search]');
          if (numberFontSearch) numberFontSearch.value = '';
          filterNumberFonts('');
          numberFontDropdown.open = false;
        }
      }
      if (event.target.matches('[data-jm-qbp-logo-file]')) {
        var logoToggle = root.querySelector('[data-jm-qbp-logo-toggle]');
        var logoPlacement = placementField('[data-jm-qbp-logo-placement]', event.target.dataset.placement);
        var hasLogoFile = Boolean(event.target.files && event.target.files[0]);
        var previewLogo = null;
        Array.prototype.some.call(root.querySelectorAll('[data-jm-qbp-preview-logo]'), function (candidate) {
          if (candidate.dataset.placement === event.target.dataset.placement) {
            previewLogo = candidate;
            return true;
          }
          return false;
        });
        if (logoPlacement) logoPlacement.checked = hasLogoFile;
        if (logoToggle) logoToggle.checked = checkedValues('[data-jm-qbp-logo-placement]').length > 0;
        if (previewLogo && hasLogoFile) {
          var logoImage = previewLogo.querySelector('[data-jm-qbp-logo-image]');
          var logoFallback = previewLogo.querySelector('[data-jm-qbp-logo-fallback]');
          var isImage = /^image\//.test(event.target.files[0].type);
          if (logoImage) {
            logoImage.hidden = !isImage;
            if (isImage) logoImage.src = URL.createObjectURL(event.target.files[0]);
          }
          if (logoFallback) logoFallback.hidden = isImage;
        }
      }
      update();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !root.hidden) close();
    });

    root.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    syncTextFontDropdown();
    syncNumberFontDropdown();
    var textFontDropdown = root.querySelector('[data-jm-qbp-font-dropdown]');
    if (textFontDropdown) {
      textFontDropdown.addEventListener('toggle', function () {
        if (!textFontDropdown.open) return;
        var textFontSearch = textFontDropdown.querySelector('[data-jm-qbp-font-search]');
        if (textFontSearch) textFontSearch.value = '';
        filterTextFonts('');
      });
    }
    var numberFontDropdown = root.querySelector('[data-jm-qbp-number-font-dropdown]');
    if (numberFontDropdown) {
      numberFontDropdown.addEventListener('toggle', function () {
        if (!numberFontDropdown.open) return;
        var numberFontSearch = numberFontDropdown.querySelector('[data-jm-qbp-number-font-search]');
        if (numberFontSearch) numberFontSearch.value = '';
        filterNumberFonts('');
      });
    }
    update();
  }

  function initAll() {
    var quickBuyRoots = Array.prototype.slice.call(document.querySelectorAll('[data-jm-qbp]'));
    var initializedSections = {};

    quickBuyRoots.reverse().forEach(function (root) {
      var sectionId = root.getAttribute('data-section-id') || '';

      if (sectionId && initializedSections[sectionId]) {
        root.remove();
        return;
      }

      if (sectionId) initializedSections[sectionId] = true;
      initQuickBuy(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
